module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="tap2shop_widget" class="wrap">\n	<div class="tap2shop_frame">\n	</div>\n	<div id="tap2shop_control" class="controls">\n		<button class="load_more">' +
((__t = ( I18n.t('widget.load_more') )) == null ? '' : __t) +
'</button>\n	</div>\n</div>';

}
return __p
}